import { Component, EventEmitter, forwardRef, Input, Output, ViewEncapsulation, OnInit } from '@angular/core';
import { FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { environment } from '../../environments/environment';
import { noop } from 'rxjs';
import { ArrowState, MenuOption, MenuPosition } from './menu-input.config';

export const CUSTOM_MENU_INPUT_CONTROL_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  // eslint-disable-next-line @angular-eslint/no-forward-ref
  useExisting: forwardRef(() => MenuInputComponent),
  multi: true,
};

@Component({
  selector: 'dn-menu-input',
  templateUrl: './menu-input.component.html',
  styleUrl: './menu-input.component.scss',
  providers: [CUSTOM_MENU_INPUT_CONTROL_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class MenuInputComponent implements OnInit {
  @Input() form: FormGroup = new FormGroup({});
  @Input() formControlName: string;
  @Input() placeholder: string;
  @Input() menuData: Array<MenuOption>;
  @Input() selectedOpt: MenuOption = undefined;
  @Input() hideValidIcon = false;
  @Input() menuPosition: MenuPosition = MenuPosition.BELOW;
  @Input() disabled: boolean;
  @Input() set prefixIcon(val: string) {
    if (val) {
      this._prefixIcon = `${environment.icons_url}/${val}.svg`;
    }
  }

  _prefixIcon: string;
  @Output() afterSelect: EventEmitter<any> = new EventEmitter();
  arrowIcon = ArrowState.DOWN;
  inValidIconUrl = `${environment.icons_url}/x_icon.svg`;
  validIconUrl = `${environment.icons_url}/v_icon.svg`;

  private innerValue: any = '';
  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;

  ngOnInit(): void {
    if (this.selectedOpt) {
      this.updateForm(this.selectedOpt);
    }
  }

  updateForm(option: MenuOption): void {
    this.value = option.value;
    this.form.get(this.formControlName).setValue(option.key);
    this.afterSelect.emit(option);
  }

  /**
   * The following lines are in order to be able to use the abilities of "ReactiveForms" in a component
   * * */
  // set accessor including call the onchange callback
  set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.onChangeCallback(v);
    }
  }

  // From ControlValueAccessor interface
  writeValue(value: any): void {
    if (value !== this.innerValue) {
      this.innerValue = value;
    }
  }

  // From ControlValueAccessor interface
  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  // From ControlValueAccessor interface
  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }

  get arrowDirection(): string {
    return `${environment.icons_url}/${this.arrowIcon}.png`;
  }

  toggleArrow(menuOpen: boolean): void {
    if (!this.menuData || !this.menuData.length) return;
    this.arrowIcon = menuOpen ? ArrowState.UP : ArrowState.DOWN;
  }
}
